module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#gallery",
      toString: function () {
        return this.url;
      }
    }